import { uniqueArray } from '../../../../../utilities'

const CHANNEL = 'Channel'
const CONVO = 'Conversation Status'
const TIME = 'Time'

export const ITEM_TYPES = {
  [CHANNEL]: { multi: true },
  [CONVO]: { multi: true },
  [TIME]: { multi: false }
}

const createID = item => `${item.type}-${item.content}`

export const ITEMS = [
  { type: CHANNEL, content: 'Live Chat' },
  { type: CHANNEL, content: 'SMS' },
  { type: CHANNEL, content: 'Email' },

  { type: CONVO, content: 'Ongoing (Active)' },
  { type: CONVO, content: 'Overdue' },
  { type: CONVO, content: 'Idle (Inactive)' },
  { type: CONVO, content: 'Resolved' },
  { type: CONVO, content: 'Closed' },
  { type: CONVO, content: 'Rejected' },

  { type: TIME, content: 'Last Hour' },
  { type: TIME, content: 'Today' },
  { type: TIME, content: 'This Week' },
  { type: TIME, content: 'Last 30 Days' },
  { type: TIME, content: 'Last 3 Months' }
].map(item => ({ ...item, id: createID(item) }))

const channelMap = {
  'Live Chat': ['integration', 'offline_integration'],
  SMS: 'sms',
  Email: 'email'
}

const convoMap = {
  'Ongoing (Active)': 'ACTIVE',
  Overdue: 'OVERDUE',
  'Idle (Inactive)': 'IDLE',
  Resolved: 'ENDED',
  Closed: 'CLOSED',
  Rejected: 'REJECTED'
}

const timeMap = {
  'Last Hour': 60,
  Today: 60 * 24,
  'This Week': 60 * 24 * 7,
  'Last 30 Days': 60 * 24 * 30,
  'Last 3 Months': 60 * 24 * 90
}

const inverter = (acc, [key, val]) => {
  if (Array.isArray(val)) {
    val.forEach(v => {
      acc[v] = key
    })
  } else {
    acc[val] = key
  }
  return acc
}

const inverseMap = {
  [CHANNEL]: Object.entries(channelMap).reduce(inverter, {}),
  [CONVO]: Object.entries(convoMap).reduce(inverter, {}),
  [TIME]: Object.entries(timeMap).reduce(inverter, {})
}

export const selectedToFilter = (selected: string[]): APIInboxViewFilter => {
  const channels: string[] = []
  const convos: string[] = []
  let time: number = 0

  const items = selected.map(opt => opt.split('-'))
  items.forEach(([key, value]) => {
    if (key === CHANNEL) {
      if (value in channelMap) {
        const toAdd = channelMap[value]
        if (typeof toAdd === 'string') {
          channels.push(toAdd)
        } else if (Array.isArray(toAdd)) {
          channels.push(...toAdd)
        }
      }
    } else if (key === CONVO) {
      if (value in convoMap) {
        convos.push(convoMap[value])
      }
    } else if (key === TIME) {
      if (value in timeMap) {
        time = timeMap[value]
      }
    }
  })

  const asFilter: APIInboxViewFilter = {}

  if (channels.length > 0) {
    asFilter.initiated_with = channels
  }
  if (convos.length > 0) {
    asFilter.state = convos
  }
  if (time > 0) {
    asFilter.created_within = time
  }

  return asFilter
}

export const filterToSelected = (filter: APIInboxViewFilter): string[] => {
  const asSelected = []

  const findIDsFromKey = (dictKey: string, keys: any[]) => {
    keys.forEach(key => {
      if (key in inverseMap[dictKey]) {
        const value = inverseMap[dictKey][key]
        const id = createID({ type: dictKey, content: value })
        if (id) {
          asSelected.push(id)
        }
      }
    })
  }

  if (filter.initiated_with) {
    findIDsFromKey(CHANNEL, filter.initiated_with)
  }

  if (filter.state) {
    findIDsFromKey(CONVO, filter.state)
  }

  if (filter.created_within) {
    findIDsFromKey(TIME, [filter.created_within])
  }

  return uniqueArray(asSelected)
}
